export default "__VITE_ASSET__18e5f529__"